import { ViewContainerRef } from '@angular/core';
import { MdDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Observable';

export interface PuiDialogConfig {
  title?: string;
  message?: string;
  width?: string;
  height?: string;
  viewContainerRef?: ViewContainerRef;
  disableClose?: boolean;
}

export interface PuiAlertConfig extends PuiDialogConfig {
  closeButton?: string;
}

export interface PuiConfirmConfig extends PuiDialogConfig {
  acceptButton?: string;
  cancelButton?: string;
}

export interface PuiPromptConfig extends PuiConfirmConfig {
  value?: string;
}

export class PuiDialogRef<T>{
  componentInstance: T;

  constructor(private dialogRef: MdDialogRef<T>) { }

  afterClosed(): Observable<any> {
    return this.dialogRef.afterClosed();
  }
}
